import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'expirationDate',
})
export class ExpirationDatePipe implements PipeTransform {
  transform(value: string): { text: string; textClass: string; bgClass: string } {
    if (!value) {
      return { text: '', textClass: '', bgClass: '' };
    }

    const currentDate = moment();
    const expirationDate = moment(value);
    if (currentDate.isAfter(expirationDate)) {
      return { text: 'Expired', textClass: 'text-status-error', bgClass: 'bg-status-error-bg' };
    } else if (expirationDate.diff(currentDate, 'days') <= 7) {
      return { text: 'Expire soon', textClass: 'text-status-warning', bgClass: 'bg-status-warning-bg' };
    } else {
      return { text: expirationDate.format('MM/DD/YYYY'), textClass: '', bgClass: '' };
    }
  }
}
